module.exports = __webpack_public_path__ + "static/img/HeNan_Banner.a27f87ce.jpg";